import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const GalleryContainer = styled("div")`
  .image-gallery {
    margin-top: 15px;
  }
  .image-gallery-image {
    min-height: 50px;
  }
`;

export const DocumentPreviewLoaderBox = styled(Box)`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;
